import { InfoCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';
import SlidingFilter from './SlidingFilter';

const highlightOptions = {
  is_fingerprinting: {
    label: 'Possible Fingerprinting',
    legend: 'Fingerprinting methods identified',
    tooltip: 'This setting displays all the vendors that are possibly fingerprinting on the vendor trace.',
  },
  is_local_storage: {
    label: 'Tracking Methods Detected',
    legend: 'Cookies, local storage or fingerprinting methods used',
    tooltip:
      'This setting displays all the vendors that are storing identifiers via cookies or local storage on the vendor trace.',
  },
};

const VendorTraceMetricLegend = ({ selectedMetric }) => {
  const highlightOption = highlightOptions?.[selectedMetric];
  if (!highlightOption) {
    return null;
  }
  return (
    <SlidingFilter className={'vendor-trace-metric-legend'} type="left">
      <div className={'vendor-trace-metric-legend-container'}>
        <div className={'title-row'}>
          <div>{highlightOption.label}</div>
          <Tooltip
            overlayClassName="diagnose--tooltip"
            title={() => {
              return (
                <div className={'tooltip-content'}>
                  <div>{highlightOption.tooltip}</div>
                </div>
              );
            }}
          >
            <InfoCircleFilled />
          </Tooltip>
        </div>
        <div className={'filter-block'}>
          <div className={'color-tags-container'}>
            <div className={'color-tag'} style={{ backgroundColor: '#CC483B' }} />
          </div>
          <div className={'checkbox-list'}>
            <div>{highlightOption.legend}</div>
          </div>
        </div>
      </div>
    </SlidingFilter>
  );
};

export default VendorTraceMetricLegend;
